import { render, staticRenderFns } from "./HeritageDivision.vue?vue&type=template&id=2eb4910f&scoped=true&"
import script from "./HeritageDivision.vue?vue&type=script&lang=js&"
export * from "./HeritageDivision.vue?vue&type=script&lang=js&"
import style0 from "./HeritageDivision.vue?vue&type=style&index=0&id=2eb4910f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb4910f",
  null
  
)

export default component.exports